/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrencyFromJSON, CurrencyToJSON } from './Currency';
import { LegalDocumentVersionsFromJSON, LegalDocumentVersionsToJSON } from './LegalDocumentVersions';
import { ProviderIdFromJSON, ProviderIdToJSON } from './ProviderId';
/**
 * Check if a given object implements the SrcApiSubscriptionsCheckoutRequest interface.
 */
export function instanceOfSrcApiSubscriptionsCheckoutRequest(value) {
    if (!('cancelUrl' in value) || value['cancelUrl'] === undefined)
        return false;
    if (!('successUrl' in value) || value['successUrl'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function SrcApiSubscriptionsCheckoutRequestFromJSON(json) {
    return SrcApiSubscriptionsCheckoutRequestFromJSONTyped(json, false);
}
export function SrcApiSubscriptionsCheckoutRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cancelUrl': json['cancel_url'],
        'currency': json['currency'] == null ? undefined : CurrencyFromJSON(json['currency']),
        'legalDocumentVersions': json['legal_document_versions'] == null ? undefined : LegalDocumentVersionsFromJSON(json['legal_document_versions']),
        'provider': json['provider'] == null ? undefined : ProviderIdFromJSON(json['provider']),
        'successUrl': json['success_url'],
        'tier': json['tier'],
        'tosAcceptedAt': json['tos_accepted_at'] == null ? undefined : json['tos_accepted_at'],
        'withdrawalWaiverAt': json['withdrawal_waiver_at'] == null ? undefined : json['withdrawal_waiver_at'],
    };
}
export function SrcApiSubscriptionsCheckoutRequestToJSON(json) {
    return SrcApiSubscriptionsCheckoutRequestToJSONTyped(json, false);
}
export function SrcApiSubscriptionsCheckoutRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cancel_url': value['cancelUrl'],
        'currency': CurrencyToJSON(value['currency']),
        'legal_document_versions': LegalDocumentVersionsToJSON(value['legalDocumentVersions']),
        'provider': ProviderIdToJSON(value['provider']),
        'success_url': value['successUrl'],
        'tier': value['tier'],
        'tos_accepted_at': value['tosAcceptedAt'],
        'withdrawal_waiver_at': value['withdrawalWaiverAt'],
    };
}
